import { buildNum } from '../../../config/build.config';

export const BuildNumber = () => {
  return buildNum ? (
    <p className='text-center text-xs text-gray py-2 border-t border-t-gray-light w-full'>
      Build {buildNum}
    </p>
  ) : null;
};
